<script lang="ts">
	import success from '$lib/assets/images/icons/success.svg';
	import __ from '$lib/stores/TranslationStore';
	import { fade } from 'svelte/transition';
	import { twMerge } from 'tailwind-merge';
	export let successText: string;
	let className: string = '';
	export { className as class };
</script>

<div
	transition:fade
	class={twMerge(
		'absolute left-0 top-0 flex h-full w-full flex-col items-center justify-center bg-white bg-opacity-90',
		className
	)}
>
	<slot name="symbol">
		<img src={success} alt="sucesso" />
	</slot>
	<h1 class="mt-4 text-center text-4xl text-primary lg:text-5xl lg:leading-54">
		<slot name="title">
			{$__('Obrigado!')}
		</slot>
	</h1>

	<h2 class="mx-auto mt-7 max-w-lg text-center text-lg font-light text-dark xl:text-xl">
		<slot name="caption" text={successText}>
			{$__('Verifique que recebeu a nossa confirmação na sua caixa de email e/ou spam.')}
			<br />
			{$__(successText)}
		</slot>
	</h2>
</div>
